// AUTO-GENERATED — DO NOT EDIT BY HAND.
//
// Source of truth:
//   core/qoe/findings/risk_sections.py   (the 11 A-K sections)
//   core/qoe/findings/_catalogue_data.py (the 74 findings and their tiers)
//   core/engagements/tiers.py            (tier keys and labels)
//
// Regenerate with:  python scripts/gen_frontend_catalogue.py
// Drift is a hard FAIL in scripts/conformance_check.py — never patch this file
// to fix a count; change the catalogue and regenerate.

export interface RiskSectionSpec {
  key: string;
  title: string;
  /** Findings this section contributes to the full catalogue. */
  count: number;
}

/** The 11 QoE risk sections, in canonical order. */
export const RISK_SECTIONS: RiskSectionSpec[] = [
  { key: "A", title: "Revenue Quality & Recognition", count: 10 },
  { key: "B", title: "Customer, Cohort & Concentration", count: 8 },
  { key: "C", title: "Gross Margin & COGS", count: 6 },
  { key: "D", title: "EBITDA & Adjustments", count: 10 },
  { key: "E", title: "Net Working Capital", count: 8 },
  { key: "F", title: "Debt & Debt-like Items", count: 6 },
  { key: "G", title: "Proof of Cash & Treasury", count: 5 },
  { key: "H", title: "Balance Sheet Quality", count: 8 },
  { key: "I", title: "Operating Expense & Run-rate", count: 6 },
  { key: "J", title: "Forecast & Sustainability", count: 4 },
  { key: "K", title: "Tax, Compliance & Diligence Flags", count: 3 },
];

export type ScopeTier = "lite" | "focused" | "full";

/** How many of the 74 findings each tier assesses. */
export const TIER_FINDING_COUNTS: Record<ScopeTier, number> = {
  lite: 17,
  focused: 54,
  full: 74,
};

/** Commercial label for each tier (matches core/engagements/tiers.py). */
export const TIER_LABELS: Record<ScopeTier, string> = {
  lite: "Essentials",
  focused: "Standard",
  full: "Comprehensive",
};

/** Total findings in the catalogue. */
export const CATALOGUE_SIZE = 74;

/** Section count — the "N sections" the UI quotes. */
export const SECTION_COUNT = 11;

/** Findings assessed at `tier`, falling back to the full catalogue. */
export function tierFindingCount(tier: string | null | undefined): number {
  const key = String(tier ?? "").toLowerCase() as ScopeTier;
  return TIER_FINDING_COUNTS[key] ?? CATALOGUE_SIZE;
}
